export default "__VITE_ASSET__BlhMbWpg__"